import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import {reaction} from 'mobx';
import {inject, observer} from 'mobx-react';
import {withRouter, routerShape, locationShape} from 'react-router';

import {withI18n} from 'spa/Components/Context';
import {Form, FormHandler, InputField} from 'spa/Components/Form';
import ProgressButton from 'spa/Components/ProgressButton';

import './ForgotPasswordForm.less';

@withRouter
@inject(({store: {notifications, resetPassword, tracker}}) => (
  {notifications, resetPassword, tracker}
))
@observer
@withI18n
class ForgotPasswordForm extends React.Component {
  static propTypes = {
    notifications: PropTypes.object.isRequired,
    resetPassword: PropTypes.shape({
      isLoading: PropTypes.bool.isRequired,
      error: PropTypes.any,
      response: PropTypes.any,
      load: PropTypes.func.isRequired,
      reset: PropTypes.func.isRequired,
    }).isRequired,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    location: locationShape.isRequired,
    router: routerShape.isRequired,
  };

  componentDidMount() {
    this.listeners = [
      reaction(
        () => this.props.resetPassword.error,
        (error) => {
          if (error) {
            this.props.notifications.add({
              id: 'forgot-password-message',
              type: 'error',
              title: this.context.i18n.__error(error),
            });
          } else {
            this.props.notifications.dismiss('forgot-password-message');
          }
        },
        {
          fireImmediately: true,
          name: 'forgot-password-error',
        },
      ),
      reaction(
        () => this.props.resetPassword.response,
        (response) => {
          if (response) {
            this.props.notifications.add({
              id: 'forgot-password-message',
              type: 'success',
              title: this.context.i18n.__('Please check your inbox'),
            });
          } else {
            this.props.notifications.dismiss('forgot-password-message');
          }
        },
        {
          fireImmediately: true,
          name: 'forgot-password-success',
        },
      ),
    ];
    this.props.tracker.track('Forgot Password', {
      category: this.props.trackingCategory,
    });
  }

  componentWillUnmount() {
    this.props.resetPassword.reset();
    while (this.listeners.length) { this.listeners.pop()(); }
  }

  @autobind onReceiveForm(state) {
    const {email} = state.body;
    this.props.resetPassword.reset();
    this.props.resetPassword.load({}, {email})
      .then((response) => {
        this.props.tracker.track('Forgot Password Reset Request Success', {
          category: this.props.trackingCategory,
          success: response && response.success,
        });
      });
  }

  render() {
    const {i18n} = this.context;
    const {location, resetPassword: {isLoading, response}} = this.props;
    const {state} = location;
    let email;
    if (state && state.body) {
      ({email} = this.props.location.state.body);
    }
    return (
      <FormHandler method="POST" onReceiveForm={this.onReceiveForm}>
        <Form
          to={{
            pathname: location.pathname,
            query: location.query,
          }}
          method="POST"
          disabled={isLoading}
          className="form"
        >
          <div className="content--indented">
            <InputField
              type="email"
              name="email"
              label={i18n.__('Email Address')}
              className="form-control"
              defaultValue={email}
              placeholder={i18n.__('john@smith.com')}
              disabled={isLoading}
            />

            <ProgressButton
              disabled={isLoading}
              loading={isLoading}
              done={!!response}
              tag="submit"
              className="forgot-password__submit"
              theme={response ? 'success' : 'primary'}
              label={response ? i18n.__('Sent') : i18n.__('Request Password Reset')}
              block
            />
          </div>
        </Form>
      </FormHandler>
    );
  }
}

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./spa/Components/Session/ForgotPasswordForm.jsx